let pagesAbortController: AbortController | null = null;

export const createAbortController = () => {
  pagesAbortController = new AbortController();
  return pagesAbortController;
};

export const getAcbortController = () => {
  return pagesAbortController;
};

export const stopAbortController = () => {
  if (pagesAbortController) {
    pagesAbortController.abort();
  }
};
